import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'
import buildPosition from 'letter/components/header/util/buildPosition'

const HeaderItemImage = ({ data }) => {
  const {
    type,
    x,
    y,
    sortId,
    metaData: {
      width,
      height,
      imageUrl,
    },
  } = data

  const styles = buildPosition({ x, y, width, height, sortId, type })

  return (
    <img src={`${config.imageResourceHost}${imageUrl}`} style={styles} />
  )
}

HeaderItemImage.propTypes = {
  data: PropTypes.object,
}

export default HeaderItemImage
